(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .factory("subscriptionCheckoutService", ["$localStorage", "currencyService", "$translate", subscriptionCheckoutService]);
    function subscriptionCheckoutService($localStorage, currencyService, $translate) {
        var subscriptionCheckoutServiceFactory = {
            wizard: {
                step: 1,
                isReady: false
            },
            model: {
                currency: currencyService.find("USD"),
                currencyName: $translate.instant("common.currency.USD"),
                dCurrency: currencyService.find("USD"),
                dCurrencyName: $translate.instant("common.currency.USD")
            }
        };
        function start(userCount, subscriptionTypeId, displayCurrency) {
            if ($localStorage.subscriptionCheckoutData) {
                subscriptionCheckoutServiceFactory.wizard = angular.copy($localStorage.subscriptionCheckoutData.wizard);
                subscriptionCheckoutServiceFactory.model = angular.copy($localStorage.subscriptionCheckoutData.model);
                delete $localStorage.subscriptionCheckoutData;
            }
            else {
                subscriptionCheckoutServiceFactory.wizard.step = 1;
                subscriptionCheckoutServiceFactory.wizard.isReady = true;
                subscriptionCheckoutServiceFactory.model = {
                    userCount: userCount,
                    subscriptionTypeId: subscriptionTypeId,
                    dCurrency: displayCurrency,
                    dCurrencyName: $translate.instant("common.currency." + displayCurrency.code),
                    currency: currencyService.find("USD"),
                    currencyName: $translate.instant("common.currency.USD")
                };
                delete subscriptionCheckoutServiceFactory.wizard.isStep1Valid;
                delete subscriptionCheckoutServiceFactory.wizard.isStep2Valid;
                delete subscriptionCheckoutServiceFactory.wizard.isStep3Valid;
                delete subscriptionCheckoutServiceFactory.wizard.isStep4Valid;
            }
        }
        function setStep(step) {
            subscriptionCheckoutServiceFactory.wizard.step = step;
        }
        function save() {
            $localStorage.subscriptionCheckoutData = {
                wizard: angular.copy(subscriptionCheckoutServiceFactory.wizard),
                model: angular.copy(subscriptionCheckoutServiceFactory.model)
            };
        }
        subscriptionCheckoutServiceFactory.start = start;
        subscriptionCheckoutServiceFactory.setStep = setStep;
        subscriptionCheckoutServiceFactory.save = save;
        return subscriptionCheckoutServiceFactory;
    }
}());
